import { render, staticRenderFns } from "./CampaignClients.vue?vue&type=template&id=902c5a98"
import script from "./CampaignClients.vue?vue&type=script&lang=js"
export * from "./CampaignClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports